export default "__VITE_ASSET__nhfUYkTI__"